import { css } from "@emotion/react";
import theme from "src/theme";
import { queries } from "@songtradr/spa-common";

export default {
  verticalTitleContainer: css`
    background-color: ${theme.colors.background.gray};
    border-bottom: 0.063rem solid ${theme.colors.background.veryLightGray};
    border-top: 0.063rem solid ${theme.colors.background.veryLightGray};

    @media ${queries.medium} {
      border-bottom: 0;
      border-top: 0;
    }

    @media ${queries.large} {
      width: 140px;
      text-align: right;
      margin-bottom: 15rem;
    }
  `,
  verticalTitle: css`
    font-family: ${theme.fonts.sofiaPro};
    font-size: 0.8rem !important;
    letter-spacing: 0.1rem;
    line-height: 1.125rem;
    text-transform: uppercase;
    height: 50px;
    padding-top: 1.5rem;
    padding-left: 1rem;
    color: ${theme.colors.background.darkGray};

    @media ${queries.medium} {
      background-color: ${theme.colors.background.gray};
      padding-top: 0;
      padding-left: 0;
      margin-bottom: 2rem;
    }

    @media ${queries.large} {
      color: ${theme.colors.black};
      letter-spacing: 0.07rem;
      transform: rotate(270deg);
      font-size: 0.8rem !important;
      font-weight: 500 !important;
    }
  `,
  overviewContainer: css`
    display: flex;
    flex-direction: column;

    @media ${queries.medium} {
      padding-left: 2rem;
      padding-right: 2rem;
      padding-top: 3.75rem;
      padding-bottom: 5rem;
      background-color: ${theme.colors.background.gray};
    }

    @media ${queries.large} {
      padding-left: 0;
      padding-right: 0;
      align-items: center;
      flex-direction: row;
    }
  `,
  overviewContentContainer: css`
    width: 100%;
    padding: 1rem;
    background-color: ${theme.colors.white};

    @media ${queries.medium} {
      background-color: ${theme.colors.background.gray};
      padding: 0;
    }

    @media ${queries.large} {
      width: 100%;
    }
  `,
  overviewDescriptionCol: css`
    @media ${queries.large} {
      margin-top: 2rem;
      padding-top: 2rem !important;
    }
  `,
  overviewTitle: css`
    font-family: ${theme.fonts.sofiaPro};
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.125rem;
    color: ${theme.colors.background.darkGray};
    display: block;
    padding-bottom: 0.7rem;
  `,
  overviewText: css`
    font-family: ${theme.fonts.sofiaPro};
    font-style: normal;
    font-weight: normal;
    font-size: 1.1rem;
    line-height: 1.5rem;
    color: ${theme.colors.black};
  `,
  sectionTitle: css`
    font-family: ${theme.fonts.sofiaPro};
    font-style: normal;
    font-weight: bold;
    font-size: 1.25rem !important;
    line-height: 1.625rem;
    padding-bottom: 1.75rem;
  `,
  overviewCol: css`
    margin-bottom: 1rem;

    @media ${queries.large} {
      margin-bottom: 2.5rem;
    }
  `,
  horizontalRule: css`
    display: none;

    @media ${queries.large} {
      display: block;
      border: 0.0625rem solid ${theme.colors.background.veryLightGray};
      width: 100%;
      margin-top: 2rem;
    }
  `,
};
